export const inputTypes={INSERT:"INSERT",DELETE_BACKWARD:"DELETE_BACKWARD",DELETE_FORWARD:"DELETE_FORWARD",UPDATE:"UPDATE"};